module.exports = __webpack_public_path__ + "static/media/inventory-summary.3ca9af1f.svg";